var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[_c('div',[(_vm.canPlayVideo)?_c('SolutionsVideo',{on:{"cannotplay":_vm.onSolutionCmpError}}):_vm._e(),_c('Solutions',{directives:[{name:"show",rawName:"v-show",value:(!_vm.canPlayVideo),expression:"!canPlayVideo"}]})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7b674c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-solutions/switch.vue
// module id = sTdJ
// module chunks = 2 3